export default "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAABCAYAAAC/iqxnAAAABHNCSVQICAgIfAhkiAAAABBJREFUCFtjLCgo+M8wgAAAJEQCUc3yy2cAAAAASUVORK5CYII="